import {Breakpoints, styled} from '@vw-marketing/us-components';
import {styledSlick} from '../../components/slick/styled';

export const StyledImageGallery = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;
  margin-bottom: 30px;

  img {
    object-fit: contain;
  }

  @media (min-width: ${Breakpoints.b560}px) {
    margin-top: 15px;
    margin-bottom: 30px;
  }
`;
export const StyledSliderCount = styled.div`
  display: block;
  width: 100%;
  height: auto;
  padding: 7px 0 3px;

  @media (min-width: ${Breakpoints.b560}px) {
    padding: 15px 0 5px;
  }
`;

interface StyledSlickContainerProps {
  isNav?: boolean;
}

export const StyledSlickContainer = styled(
  styledSlick,
)<StyledSlickContainerProps>`
  &.gallery-nav-carousel {
    .slick-slide {
      cursor: pointer;
    }
  }

  .slick-prev:before {
    content: '‹';
  }

  .slick-next:before {
    content: '›';
  }

  .slick-next:before,
  .slick-prev:before {
    display: flex;
    justify-content: space-evenly;
    margin-top: -4px;
    font-size: 22px;
    color: #011e50;
  }

  .slick-next,
  .slick-prev {
    background: #fff;
    border: solid 1px #ccc;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    z-index: 1;
    cursor: pointer;
  }

  .slick-next {
    position: absolute;
    right: 20px;
    bottom: 46%;
  }

  .slick-prev {
    position: absolute;
    left: 20px;
    top: 48%;
  }

  .slick-disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  ${({isNav}) =>
    `${
      isNav
        ? `.slick-track {
            display: flex !important;
            align-items: center;
            column-gap: 6px;

            > div:not(.slick-current) {
              opacity: 0.5;
            }

            > div:first-child {
              margin-left: -6px;
            }

            > div:last-child {
              margin-right: -6px;
            }

            img {
              max-height: 50px;
            }
          }

          @media (min-width: ${Breakpoints.b560}px) {
            .slick-track {
              column-gap: 11px;

              > div:first-child {
                margin-left: -11px;
              }

              > div:last-child {
                margin-right: -11px;
              }

              img {
                max-height: 85px;
              }
            }
          }

          @media (min-width: ${Breakpoints.b960}px) {
            .slick-track {
              img {
                max-height: 116px;
              }
            }
          }

          @media (min-width: ${Breakpoints.b1280}px) {
            .slick-track {
              column-gap: 13px;

              > div:first-child {
                margin-left: -13px;
              }

              > div:last-child {
                margin-right: -13px;
              }

              img {
                max-height: 85px;
              }
            }
          }
          @media (min-width: ${Breakpoints.b1600}px) {
            .slick-track {
              img {
                max-height: 102px;
              }
            }
          }

          @media (min-width: ${Breakpoints.b1920}px) {
            .slick-track {
              img {
                max-height: 138px;
              }
            }
          }
          `
        : `
          .slick-track {
            display: flex;
            align-items: center;

            img {
              max-height: 262px;
            }

            @media (min-width: ${Breakpoints.b560}px) {
              img {
                max-height: 448px;
              }
            }

            @media (min-width: ${Breakpoints.b960}px) {
              img {
                max-height: 600px;
              }
            }

            @media (min-width: ${Breakpoints.b1280}px) {
              img {
                max-height: 450px;
              }
            }

            @media (min-width: ${Breakpoints.b1600}px) {
              img {
                max-height: 534px;
              }
            }

            @media (min-width: ${Breakpoints.b1920}px) {
              img {
                max-height: 718px;
              }
            }
          }
        `
    };`}
`;
